
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9e03"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9e03"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k1AmO", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $e9401c56a2b35115$export$6503ec6e8aabbaf; }, function (v) { return $e9401c56a2b35115$export$6503ec6e8aabbaf = v; });
var $e9401c56a2b35115$export$6503ec6e8aabbaf;
var $e9401c56a2b35115$export$f7ad0328861e2f03;
"use strict";
var $e9401c56a2b35115$var$mapping = new Map();
function $e9401c56a2b35115$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$e9401c56a2b35115$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $e9401c56a2b35115$var$resolve(id) {
    var resolved = $e9401c56a2b35115$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$e9401c56a2b35115$export$6503ec6e8aabbaf = $e9401c56a2b35115$var$register;
$e9401c56a2b35115$export$f7ad0328861e2f03 = $e9401c56a2b35115$var$resolve;

});

var $c0afc8a9c816585f$exports = {};

(parcelRequire("k1AmO")).register(new URL("", import.meta.url).toString(), JSON.parse('["5O16I","index.1d9d106c.js","4orQ0","wireguard-logo.324e798b.png","lEVf6","user.513216f8.png","MGGXM","qr.b290a2ae.png","iZgJ2","download.175f4a2f.png","jPVwH","delete.4ca64d03.png","2Y2Iu","plus.1d36d883.png"]'));


//# sourceMappingURL=index.runtime.d4233d4b.js.map
